import React from "react";

const ErrorAlert = ({ error }) => {
    if (!error || (Array.isArray(error) && error.length === 0)) {
        // ✅ No error or empty array
        return null;
    }

    return (
        <div className="mt-4 p-3 bg-red-400 rounded-lg">
            {Array.isArray(error) ? (
                <ul className="list-disc list-outside pl-5 text-white space-y-1">
                    {error.map((err, i) => (
                        <li key={i} className="text-sm leading-relaxed">
                            {err}
                        </li>
                    ))}
                </ul>
            ) : (
                // ✅ When error is a string
                <p className="text-white text-sm leading-relaxed">{error}</p>
            )}
        </div>
    );
};

export default ErrorAlert;
